import { render, staticRenderFns } from "./messageReports.vue?vue&type=template&id=de6dcece"
import script from "./messageReports.vue?vue&type=script&lang=js"
export * from "./messageReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports